export default function AboutPage() {
  return (
    <div className="container-narrow py-8">
      <h1 className="font-bold text-2xl mb-4">About Squids</h1>
      <div className="space-y-4 text-text-muted">
        <p>Squids is a next-generation Q&A and social discussion platform for the African continent and beyond.</p>
        <p>Built with ❤️ by TyVila.Online, Johannesburg, South Africa.</p>
      </div>
    </div>
  )
}